export const biReportsRouteDef = [ 
    {
        path: 'template_loader/:code',
        component:'TemplateLoaderComponent',
        data : {
            selector: 'template-loader'
        }
    }
]       


